import { useEffect, useState } from 'react'

import { useAppDispatch } from 'store'
import { CollectionActions } from 'store/pages/collection'

interface Props {
  codes: string[]
}

const useBulkCollectionData = (props: Props) => {
  const { codes } = props

  const dispatch = useAppDispatch()

  const [collectionsFetchedAlready, setCollectionsFetchedAlready] = useState<boolean>(false)

  useEffect(() => {
    if (!collectionsFetchedAlready) {
      dispatch(CollectionActions.getBulkData({ codes }))
      setCollectionsFetchedAlready(true)
    }
  }, [codes])

}

export default useBulkCollectionData
